module.exports = __webpack_public_path__ + "img/womfest.b63964f5.jpg";